import { Outlet } from "react-router";

const AppointmentsPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default AppointmentsPage;
